<template>
    <div id="app">
        <div class="content">
            <client-only>
                <HeaderOrder />
                <!--            <NotifyVPN></NotifyVPN>-->
                <div class="sub-header" v-if="showCrumbs">
                    <div class="container">
                        <breadcrumbs />
                    </div>
                </div>
            </client-only>
            <nuxt />
            <client-only>
                <FooterInner />
                <NotifyModal />
                <CartLimitModal />
                <SupportWidget />
                <SubscribePopup2 />
                <CookiesModal />
                <!--            <CountryModal/>-->
            </client-only>
        </div>
    </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import HeaderOrder from "@/components/HeaderOrder.vue";
import FooterInner from "@/components/FooterInner.vue";
import NotifyModal from "@/components/NotifyModal.vue";
import CartLimitModal from "@/components/ui/CartLimitModal.vue";
import SupportWidget from "../components/ui/SupportWidget.vue";
// import NotifyVPN from "../components/NotifyVPN.vue";
import SubscribePopup2 from "@/components/ui/SubscribePopup2.vue";
import CookiesModal from "@/components/ui/CookiesModal.vue";
// import CountryModal from "@/components/CountryModal.vue";

export default {
    name: "App",
    components: {
        SubscribePopup2,
        SupportWidget,
        // NotifyVPN,
        CartLimitModal,
        Breadcrumbs,
        HeaderOrder,
        FooterInner,
        NotifyModal,
        CookiesModal,
        // CountryModal
    },
    data() {
        return {
            isMac: false,
        };
    },
    computed: {
        bodyClass() {
            let bodyClass = this.$device.isDesktop ? "is_desktop" : "is_mobile";
            bodyClass += this.isMac ? " is_apple" : "";
            bodyClass += " page-" + this.$route.name;
            bodyClass += this.showCrumbs ? "" : " no-subheader";

            return bodyClass;
        },
        showCrumbs() {
            return this.$device.isDesktop && this.$route.name !== "index";
        },
    },
    head() {
        return {
            script: [
                {
                    src: "https://widget.payselection.com/lib/pay-widget.js",
                },
            ],
            meta: [{ rel: "canonical", href: "https://post-post-scriptum.com" + this.$route.path }],
            bodyAttrs: {
                class: this.bodyClass,
            },
        };
    },
    watch: {
        $device() {
            if (this.$device.isIos || this.$device.isMacOS) this.isMac = true;
        },
    },
    mounted() {
        this.isMac = this.$device.isIos || this.$device.isMacOS;

        if (this.$device.isDesktop) {
            document.querySelector("body").style.setProperty("--footer-height", 0 + "px");
        }
    },
};
</script>
